import type {ProficiencyLevel} from './types';

/** Server-side FunWithFlags name, shared with the earlier automated skill paths work. */
export const AUTOMATED_SKILL_PATHS_FLAG = 'automated_skill_paths';

/** Mirrors the policy's `max_skills` (mandark config `:automated_skill_path`). Change both together. */
export const MAX_SKILLS_PER_STUDENT = 20;

export const LEVEL_LABELS: Record<ProficiencyLevel, string> = {
  UNRANKED: 'Unranked',
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced'
};
